import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';

import { axiosConfig } from '@/api/axiosConfig';
import { baseUrl, coreBaseUrl, zepBaseUrl } from '@/consts/env';

export interface AvatarColorsResponse {
  colors: Record<string, string>;
}

interface UseAvatarColorsParams {
  category: 'hair' | 'clothes' | 'face' | 'skin';
  service?: 'core' | 'quiz';
}

export function resolveAvatarColorsOrigin(
  coreOrigin: string | undefined,
  zepOrigin: string | undefined,
  webOrigin: string,
) {
  return zepOrigin?.trim() || coreOrigin?.trim() || webOrigin;
}

export function buildAvatarColorsUrl(origin: string) {
  return new URL('/api/avatar/parts/colors', origin).toString();
}

const AVATAR_COLORS_INSTANCE = Axios.create({
  ...axiosConfig,
  baseURL: `${resolveAvatarColorsOrigin(
    coreBaseUrl,
    zepBaseUrl,
    baseUrl,
  )}/api/`,
});

export function useAvatarColors({ category, service }: UseAvatarColorsParams) {
  return useQuery({
    queryKey: ['avatar-colors', service, category],
    queryFn: async () => {
      const { data } = await AVATAR_COLORS_INSTANCE.get<AvatarColorsResponse>(
        '/avatar/parts/colors',
        {
          params: service ? { category, service } : { category },
        },
      );
      return data.colors ?? {};
    },
    staleTime: 5 * 60 * 1000,
  });
}
